module.exports = __webpack_public_path__ + "img/Xiaomi.0f080d53.jpg";